import { components } from "react-select";

const { DropdownIndicator } = components;

const CaretDownIcon = () => {
	return <svg width="10" height="5" viewBox="0 0 10 5" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M10 5L5 -4.37114e-07L0 5L10 5Z" fill="#0003B1" />
	</svg>

};

const CaretUpIcon = () => {
	return <svg width="10" height="5" viewBox="0 0 10 5" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M0 0L5 5L10 0H0Z" fill="#0003B1" />
	</svg>
};

export const CustomDropdownIndicator = (props) => {
	const {
		selectProps: { menuIsOpen }
	} = props;
	return (
		<DropdownIndicator {...props}>
			{menuIsOpen ? <CaretDownIcon /> : <CaretUpIcon />}
		</DropdownIndicator>
	);
};
